import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </span>
              <span className="text-xl font-heading font-bold text-background-50">
                韩漫漫画网
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              最新最全的韩国漫画在线阅读平台，每日更新，免费下拉式阅读。为您推荐热门韩漫和最火排行榜。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4 whitespace-nowrap">快速链接</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4 whitespace-nowrap">热门分类</h4>
            <div className="flex flex-col gap-2.5">
              {categories.slice(0, 6).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap"
                >
                  {cat.name}漫画
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4 whitespace-nowrap">联系与声明</h4>
            <div className="flex flex-col gap-2.5">
              <p className="text-sm text-background-400">邮箱：contact@tianbaolaowu.cn</p>
              <p className="text-sm text-background-400">本站内容仅供学习交流</p>
              <p className="text-sm text-background-400">请支持正版漫画</p>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500 whitespace-nowrap">
            &copy; 2024 韩漫漫画网 - 版权所有
          </p>
          <p className="text-xs text-background-500 whitespace-nowrap">
            本站所有漫画均来自网络，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}